import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimesCircle,
  faInfoCircle,
  faCheckCircle,
  faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";
import { NonBreakingSpace } from "./NonBreakingSpace";

type SubmitMessageProps = {
  message: string;
  visible?: boolean;
  alertType?: "success" | "info" | "warning" | "danger";
  className?: string;
  wrapperClassName?: string;
};

/**
 * Message component for displaying form submission feedback
 * - Used for success, error, and info messages throughout the application
 * - Provides visual context through appropriate colors and icons
 */
export function SubmitMessage(props: SubmitMessageProps) {
  const {
    message = "",
    alertType = "info",
    className = "",
    wrapperClassName = "submit-message__wrapper",
    visible = false
  } = props;

  if (visible === false) {
    return null;
  }

  const alertTypes = {
    success: {
      icon: faCheckCircle,
      className: "alert alert-success"
    },
    info: {
      icon: faInfoCircle,
      className: "alert alert-info"
    },
    warning: {
      icon: faExclamationCircle,
      className: "alert alert-warning"
    },
    danger: {
      icon: faTimesCircle,
      className: "alert alert-danger"
    }
  };
  const alertClass = alertTypes[alertType]?.className || alertTypes["info"].className;
  const alertIcon = alertTypes[alertType]?.icon || alertTypes["info"].icon;

  return (
    <div className={wrapperClassName}>
      <div className={`submit-message ${className} ${alertClass}`} role="alert">
        <FontAwesomeIcon icon={alertIcon} />
        <NonBreakingSpace size={2} /> {message}
      </div>
    </div>
  );
}

export default SubmitMessage;
